import $ from 'jquery';

$(document).on('ready', () => {
  let isApprovedToSignUp = false;
  const fundsRemaining = Boolean(window.wlFipFundsRemaining.funds);
  let searchParams = new URLSearchParams(window.location.search);
  let apply = searchParams.get('apply');

  const enableContinueBtn = () => {
    const radioAmounts = $('.apply__fields').find('.form__field').length;
    const checkedRadios = $('.apply__fields').find(
      'input[type="radio"]:checked'
    );

    if (checkedRadios.length !== radioAmounts) {
      $('#fip-apply-continue').prop('disabled', true);
    } else {
      $('#fip-apply-continue').prop('disabled', false);
    }

    checkedRadios.each((i, element) => {
      if ($(element).val() == '0') {
        isApprovedToSignUp = false;
        return false;
      } else {
        isApprovedToSignUp = true;
        return true;
      }
    });
  };

  const showForm = () => {
    $('.hero--fip')
      .addClass('hero--fip--apply')
      .removeClass('hero--fip--landing');

    const $landingSection = $('[data-section="landing"]');
    const $applySection = $('[data-section="apply"]');

    $applySection.css({
      opacity: 0,
      paddingTop: '10px'
    });

    $landingSection.animate(
      {
        opacity: 0,
        paddingTop: '10px'
      },
      300,
      'swing',
      () => {
        $landingSection.hide();

        $applySection.delay(100).removeClass('u--display-none').show().animate(
          {
            opacity: 1,
            paddingTop: '-10px'
          },
          300,
          'swing'
        );
      }
    );
  };

  /* Event handlers */
  if (apply) {
    showForm();
  }

  $('#fip-apply').on('click', showForm);

  $('input[type="radio"]').on('change', () => enableContinueBtn());

  $('#fip-apply-continue').on('click', (event) => {
    $('.apply-notice').hide().removeClass('u--display-none');

    if (isApprovedToSignUp && fundsRemaining) {
      window.location.href = `/account/signup/?redirect_to=${$(
        event.currentTarget
      ).data('redirect')}`;
    } else {
      $('.apply-notice').show();
    }
  });
});
